function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('.menu-drawer__close-button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

function initCustomDawnMenus() {
  const isModifiedClick = (event) => {
    if (!event) return false;
    return event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
  };

  const desktopIntentQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');

  document.querySelectorAll('.zd-desktop-menu').forEach((menu) => {
    if (!desktopIntentQuery.matches) {
      menu.removeAttribute('data-zd-intent');
      return;
    }
    if (menu.dataset.zdDesktopIntentReady === 'true') return;
    menu.dataset.zdDesktopIntentReady = 'true';
    menu.dataset.zdIntent = 'true';

    const branchItems = Array.from(menu.querySelectorAll('.zd-desktop-menu__level1-item[data-zd-branch-order]'));
    const panels = Array.from(menu.querySelectorAll('.zd-desktop-menu__panel[data-zd-branch-order]'));
    if (!branchItems.length || !panels.length) return;

    const branchMap = new Map(branchItems.map((item) => [String(item.dataset.zdBranchOrder || ''), item]));
    const panelMap = new Map(panels.map((panel) => [String(panel.dataset.zdBranchOrder || ''), panel]));

    const OPEN_BRANCH_DELAY_MS = 110;
    const OPEN_CHILD_DELAY_MS = 85;
    const CLOSE_DELAY_MS = 220;

    const getDefaultBranchOrder = () => {
      const activeBranch = branchItems.find((item) => item.classList.contains('is-active'));
      if (activeBranch && activeBranch.dataset.zdBranchOrder) return String(activeBranch.dataset.zdBranchOrder);
      const activePanel = panels.find((panel) => panel.classList.contains('is-active'));
      if (activePanel && activePanel.dataset.zdBranchOrder) return String(activePanel.dataset.zdBranchOrder);
      return String(branchItems[0]?.dataset.zdBranchOrder || '');
    };

    const state = {
      defaultBranchOrder: getDefaultBranchOrder(),
      openBranchOrder: '',
      openChildOrder: '',
      pendingBranchOrder: '',
      pendingChildBranchOrder: '',
      pendingChildOrder: '',
      branchTimer: null,
      childTimer: null,
      closeTimer: null,
      lastPointer: null,
    };

    const positionBranchLevel2 = (branchOrder) => {
      const resolvedBranchOrder = String(branchOrder || '');
      const branchItem = branchMap.get(resolvedBranchOrder);
      const panel = panelMap.get(resolvedBranchOrder);
      if (!branchItem || !panel) return;

      const shell = panel.querySelector('.zd-desktop-menu__level2-shell');
      const list = panel.querySelector('.zd-desktop-menu__level2');
      if (!shell || !list) return;

      list.style.setProperty('--zd-level2-offset', '0px');

      if (!desktopIntentQuery.matches || window.innerWidth <= 1440) return;

      const shellRect = shell.getBoundingClientRect();
      const listRect = list.getBoundingClientRect();
      const branchRect = branchItem.getBoundingClientRect();

      if (!shellRect.width || !listRect.width || !branchRect.width) return;

      const maxOffset = Math.max(0, shellRect.width - listRect.width);
      if (maxOffset <= 0) return;

      const branchCenter = (branchRect.left - shellRect.left) + (branchRect.width / 2);
      const desiredOffset = branchCenter - (listRect.width / 2);
      const clampedOffset = Math.min(Math.max(0, desiredOffset), maxOffset);

      list.style.setProperty('--zd-level2-offset', `${clampedOffset}px`);
    };

    const positionOpenBranchLevel2 = () => {
      const branchOrder = state.openBranchOrder || state.defaultBranchOrder;
      if (!branchOrder) return;
      window.requestAnimationFrame(() => positionBranchLevel2(branchOrder));
    };

    const clearBranchTimer = () => {
      if (state.branchTimer) {
        window.clearTimeout(state.branchTimer);
        state.branchTimer = null;
      }
      state.pendingBranchOrder = '';
    };

    const clearChildTimer = () => {
      if (state.childTimer) {
        window.clearTimeout(state.childTimer);
        state.childTimer = null;
      }
      state.pendingChildBranchOrder = '';
      state.pendingChildOrder = '';
    };

    const clearCloseTimer = () => {
      if (state.closeTimer) {
        window.clearTimeout(state.closeTimer);
        state.closeTimer = null;
      }
    };

    const syncChildState = (branchOrder, childOrder) => {
      panels.forEach((panel) => {
        const isCurrentBranch = String(panel.dataset.zdBranchOrder || '') === String(branchOrder);
        const wrap = panel.querySelector('.zd-desktop-menu__level3-wrap');
        const childItems = Array.from(panel.querySelectorAll('.zd-desktop-menu__level2-item[data-zd-child-order]'));
        const childLinks = Array.from(panel.querySelectorAll('.zd-desktop-menu__level2-link'));
        const grids = Array.from(panel.querySelectorAll('.zd-desktop-menu__level3-grid[data-zd-child-order]'));
        const hasOpenGrid = isCurrentBranch && childOrder !== '';

        if (wrap) wrap.classList.toggle('is-open', hasOpenGrid);

        childItems.forEach((item) => {
          const isOpen = hasOpenGrid && String(item.dataset.zdChildOrder || '') === String(childOrder);
          item.classList.toggle('is-open', isOpen);
        });

        childLinks.forEach((link) => {
          const parentItem = link.closest('.zd-desktop-menu__level2-item[data-zd-child-order]');
          const isOpen = hasOpenGrid && parentItem && String(parentItem.dataset.zdChildOrder || '') === String(childOrder);
          link.classList.toggle('is-open', Boolean(isOpen));
        });

        grids.forEach((grid) => {
          const isOpen = hasOpenGrid && String(grid.dataset.zdChildOrder || '') === String(childOrder);
          grid.classList.toggle('is-open', isOpen);
        });
      });
    };

    const openBranch = (branchOrder, options = {}) => {
      const resolvedBranchOrder = branchMap.has(String(branchOrder)) ? String(branchOrder) : state.defaultBranchOrder;
      const nextChildOrder = Object.prototype.hasOwnProperty.call(options, 'childOrder')
        ? String(options.childOrder || '')
        : '';

      state.pendingBranchOrder = '';
      state.pendingChildBranchOrder = '';
      state.pendingChildOrder = '';
      state.openBranchOrder = resolvedBranchOrder;
      state.openChildOrder = nextChildOrder;

      branchItems.forEach((item) => {
        const isOpen = String(item.dataset.zdBranchOrder || '') === resolvedBranchOrder;
        item.classList.toggle('is-open', isOpen);
      });

      panels.forEach((panel) => {
        const isOpen = String(panel.dataset.zdBranchOrder || '') === resolvedBranchOrder;
        panel.classList.toggle('is-open', isOpen);
      });

      syncChildState(resolvedBranchOrder, nextChildOrder);
      positionOpenBranchLevel2();
    };

    const scheduleBranchOpen = (branchOrder, delay = OPEN_BRANCH_DELAY_MS) => {
      clearBranchTimer();
      clearCloseTimer();
      if (String(branchOrder) === String(state.openBranchOrder)) return;
      state.pendingBranchOrder = String(branchOrder || '');
      state.branchTimer = window.setTimeout(() => {
        openBranch(branchOrder);
        state.branchTimer = null;
      }, delay);
    };

    const scheduleChildOpen = (branchOrder, childOrder, delay = OPEN_CHILD_DELAY_MS) => {
      clearChildTimer();
      clearCloseTimer();

      if (String(branchOrder) !== String(state.openBranchOrder)) {
        openBranch(branchOrder, { childOrder: '' });
      }

      if (String(childOrder || '') === String(state.openChildOrder || '')) return;

      state.pendingChildBranchOrder = String(branchOrder || '');
      state.pendingChildOrder = String(childOrder || '');
      state.childTimer = window.setTimeout(() => {
        state.openChildOrder = String(childOrder || '');
        state.pendingChildBranchOrder = '';
        state.pendingChildOrder = '';
        syncChildState(state.openBranchOrder, state.openChildOrder);
        state.childTimer = null;
      }, delay);
    };

    const scheduleReset = () => {
      clearCloseTimer();
      state.closeTimer = window.setTimeout(() => {
        openBranch(state.defaultBranchOrder);
        state.closeTimer = null;
      }, CLOSE_DELAY_MS);
    };

    const cancelTimers = () => {
      clearBranchTimer();
      clearChildTimer();
      clearCloseTimer();
    };

    const pointerMovedBelow = (element) => {
      if (!state.lastPointer || !element) return false;
      const rect = element.getBoundingClientRect();
      return state.lastPointer.y >= rect.bottom - 2;
    };

    branchItems.forEach((item) => {
      const branchOrder = String(item.dataset.zdBranchOrder || '');
      const panel = panelMap.get(branchOrder);
      const trigger = item.querySelector('.zd-desktop-menu__level1-trigger-label');
      if (!branchOrder || !panel || !trigger) return;

      trigger.addEventListener('pointerenter', () => {
        cancelTimers();
        scheduleBranchOpen(branchOrder);
      });

      item.addEventListener('focusin', () => {
        cancelTimers();
        openBranch(branchOrder);
      });

      trigger.addEventListener('pointerleave', () => {
        if (state.pendingBranchOrder !== branchOrder) return;
        if (pointerMovedBelow(trigger)) {
          clearBranchTimer();
          openBranch(branchOrder);
          return;
        }
        clearBranchTimer();
      });
    });

    panels.forEach((panel) => {
      const branchOrder = String(panel.dataset.zdBranchOrder || '');
      panel.addEventListener('pointerenter', () => {
        if (state.pendingBranchOrder && state.pendingBranchOrder !== branchOrder) return;
        cancelTimers();
        if (branchOrder && branchOrder !== state.openBranchOrder) {
          openBranch(branchOrder);
        }
      });

      panel.querySelectorAll('.zd-desktop-menu__level2-item[data-zd-child-order]').forEach((item) => {
        const childOrder = String(item.dataset.zdChildOrder || '');
        const hasLevel3 = item.classList.contains('has-children');
        const trigger = item.querySelector('.zd-desktop-menu__level2-link');
        if (!trigger) return;

        trigger.addEventListener('pointerenter', () => {
          cancelTimers();
          scheduleChildOpen(branchOrder, hasLevel3 ? childOrder : '');
        });

        item.addEventListener('focusin', () => {
          cancelTimers();
          if (branchOrder && branchOrder !== state.openBranchOrder) {
            openBranch(branchOrder, { childOrder: '' });
          }
          state.openChildOrder = hasLevel3 ? childOrder : '';
          syncChildState(state.openBranchOrder, state.openChildOrder);
        });

        trigger.addEventListener('pointerleave', () => {
          if (!hasLevel3) return;
          if (state.pendingChildBranchOrder !== branchOrder || state.pendingChildOrder !== childOrder) return;
          if (pointerMovedBelow(trigger)) {
            clearChildTimer();
            state.openChildOrder = childOrder;
            syncChildState(state.openBranchOrder, state.openChildOrder);
            return;
          }
          clearChildTimer();
        });
      });

      panel.querySelectorAll('.zd-desktop-menu__level3-grid[data-zd-child-order]').forEach((grid) => {
        const childOrder = String(grid.dataset.zdChildOrder || '');
        grid.addEventListener('pointerenter', () => {
          if (
            state.pendingChildBranchOrder === branchOrder
            && state.pendingChildOrder
            && state.pendingChildOrder !== childOrder
          ) {
            return;
          }
          cancelTimers();
          if (branchOrder && branchOrder !== state.openBranchOrder) {
            openBranch(branchOrder, { childOrder });
            return;
          }
          if (childOrder !== state.openChildOrder) {
            state.openChildOrder = childOrder;
            syncChildState(state.openBranchOrder, state.openChildOrder);
          }
        });
      });
    });

    menu.addEventListener('pointermove', (event) => {
      state.lastPointer = {
        x: event.clientX,
        y: event.clientY,
      };
    });

    menu.addEventListener('pointerleave', () => {
      clearBranchTimer();
      clearChildTimer();
      scheduleReset();
    });

    menu.addEventListener('pointerenter', cancelTimers);

    menu.addEventListener('focusout', () => {
      window.setTimeout(() => {
        if (menu.contains(document.activeElement)) return;
        openBranch(state.defaultBranchOrder);
      }, 0);
    });

    openBranch(state.defaultBranchOrder);

    window.addEventListener('resize', debounce(positionOpenBranchLevel2, 60));
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(positionOpenBranchLevel2).catch(() => {});
    }
  });

  document.querySelectorAll('[data-zd-mobile-menu]').forEach((menu) => {
    if (menu.dataset.zdReady === 'true') return;
    menu.dataset.zdReady = 'true';

    const topView = menu.querySelector('[data-zd-mobile-view="top"]');
    const topButtons = Array.from(menu.querySelectorAll('[data-zd-mobile-top-trigger]'));
    const topPanels = Array.from(menu.querySelectorAll('[data-zd-mobile-top-panel]'));
    const childViews = Array.from(menu.querySelectorAll('[data-zd-mobile-view="child"]'));
    const childOpenButtons = Array.from(menu.querySelectorAll('[data-zd-mobile-child-open]'));
    const backButtons = Array.from(menu.querySelectorAll('[data-zd-mobile-back]'));
    const closeButtons = Array.from(menu.querySelectorAll('[data-zd-mobile-close]'));
    const drawerDetails = menu.closest('details');
    const drawerSummary = drawerDetails ? drawerDetails.querySelector('summary') : null;

    const activateMobileTop = (topKey) => {
      topButtons.forEach((button) => {
        button.classList.toggle('is-active', button.dataset.zdMobileTopTrigger === topKey);
      });
      topPanels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.zdMobileTopPanel === topKey);
      });
    };

    const showTopView = () => {
      if (topView) topView.classList.add('is-active');
      childViews.forEach((view) => view.classList.remove('is-active'));
    };

    const showChildView = (childKey) => {
      if (topView) topView.classList.remove('is-active');
      childViews.forEach((view) => {
        view.classList.toggle('is-active', view.dataset.zdMobileChildPanel === childKey);
      });
    };

    topButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        if (isModifiedClick(event)) return;
        event.preventDefault();
        event.stopPropagation();
        showTopView();
        activateMobileTop(button.dataset.zdMobileTopTrigger);
      });
    });

    childOpenButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        showChildView(button.dataset.zdMobileChildOpen);
      });
    });

    backButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        showTopView();
      });
    });

    closeButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (drawerDetails && drawerDetails.hasAttribute('open') && drawerSummary) {
          drawerSummary.click();
        }
      });
    });

    const firstTop = topButtons.find((button) => button.classList.contains('is-active')) || topButtons[0];
    if (firstTop) activateMobileTop(firstTop.dataset.zdMobileTopTrigger);
    showTopView();

    if (drawerDetails) {
      drawerDetails.addEventListener('toggle', () => {
        if (drawerDetails.hasAttribute('open')) {
          showTopView();
          const defaultTop = topButtons.find((button) => button.classList.contains('is-active')) || topButtons[0];
          if (defaultTop) activateMobileTop(defaultTop.dataset.zdMobileTopTrigger);
        }
      });
    }
  });
}

function initZDFacetAutoClose() {
  if (document.body.dataset.zdFacetAutoCloseReady === 'true') return;
  document.body.dataset.zdFacetAutoCloseReady = 'true';

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (!target.closest('.zd-collection-modern-filters #FacetFiltersForm')) return;
    if (target.type !== 'radio' && target.type !== 'checkbox') return;

    const details = target.closest('details.js-filter');
    if (!details) return;
    details.removeAttribute('open');
    details.classList.remove('menu-opening');
    const summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  }, true);
}

function initZDFacetSummaryToggleFix() {
  document.querySelectorAll('.zd-collection-modern-filters #FacetFiltersForm').forEach((form) => {
    if (form.dataset.zdFacetSummaryFixReady === 'true') return;
    form.dataset.zdFacetSummaryFixReady = 'true';

    const detailsList = () => Array.from(form.querySelectorAll('details.js-filter'));

    detailsList().forEach((details) => {
      const summary = details.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const isOpen = details.hasAttribute('open');
        detailsList().forEach((other) => {
          if (other === details) return;
          other.removeAttribute('open');
          other.classList.remove('menu-opening');
          const otherSummary = other.querySelector('summary');
          if (otherSummary) otherSummary.setAttribute('aria-expanded', 'false');
        });

        if (isOpen) {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        } else {
          details.setAttribute('open', '');
          summary.setAttribute('aria-expanded', 'true');
        }
      });
    });

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (target.closest('.zd-collection-modern-filters #FacetFiltersForm details.js-filter')) return;

      detailsList().forEach((details) => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
        const summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      });
    });
  });
}

function initZDSideNavToggles() {
  document.querySelectorAll('.zd-collection-side-nav').forEach((nav) => {
    if (nav.dataset.zdToggleReady === 'true') return;
    nav.dataset.zdToggleReady = 'true';

    const setExpanded = (targetId, expanded) => {
      if (!targetId) return;
      const panel = nav.ownerDocument.getElementById(targetId);
      if (panel) {
        panel.classList.toggle('is-collapsed', !expanded);
        panel.hidden = !expanded;
      }
      nav.querySelectorAll(`[data-zd-side-toggle="${targetId}"]`).forEach((trigger) => {
        trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    };

    nav.querySelectorAll('[data-zd-side-toggle]').forEach((trigger) => {
      const targetId = trigger.getAttribute('data-zd-side-toggle');
      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
      setExpanded(targetId, isExpanded);

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const currentlyExpanded = trigger.getAttribute('aria-expanded') === 'true';
        setExpanded(targetId, !currentlyExpanded);
      });
    });
  });
}

let zdIconTooltipElement = null;
function initZDHeaderIconTooltips() {
  const targets = document.querySelectorAll('.announcement-bar__icon-link[data-tooltip], .header__icon[data-tooltip]');
  if (!targets.length) return;

  const ensureTooltipElement = () => {
    if (zdIconTooltipElement) return zdIconTooltipElement;
    const tooltip = document.createElement('div');
    tooltip.className = 'zd-hover-tooltip';
    tooltip.setAttribute('role', 'tooltip');
    tooltip.setAttribute('aria-hidden', 'true');
    document.body.appendChild(tooltip);
    zdIconTooltipElement = tooltip;
    return tooltip;
  };

  const hideTooltip = () => {
    if (!zdIconTooltipElement) return;
    zdIconTooltipElement.classList.remove('is-visible');
    zdIconTooltipElement.setAttribute('aria-hidden', 'true');
  };

  const showTooltip = (target) => {
    const label = (target.getAttribute('data-tooltip') || '').trim();
    if (!label) return;
    const tooltip = ensureTooltipElement();
    const rect = target.getBoundingClientRect();
    tooltip.textContent = label;
    tooltip.style.left = `${Math.round(rect.left + rect.width / 2)}px`;
    tooltip.style.top = `${Math.round(rect.bottom + 10)}px`;
    tooltip.classList.add('is-visible');
    tooltip.setAttribute('aria-hidden', 'false');
  };

  targets.forEach((target) => {
    if (target.dataset.zdTooltipBound === 'true') return;
    target.dataset.zdTooltipBound = 'true';

    target.addEventListener('mouseenter', () => showTooltip(target));
    target.addEventListener('focusin', () => showTooltip(target));
    target.addEventListener('mouseleave', hideTooltip);
    target.addEventListener('blur', hideTooltip);
  });

  if (!document.body.dataset.zdTooltipGlobalBound) {
    document.body.dataset.zdTooltipGlobalBound = 'true';
    window.addEventListener('scroll', hideTooltip, { passive: true });
    window.addEventListener('resize', hideTooltip, { passive: true });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') hideTooltip();
    });
  }
}

const ZD_SCALE_FILTER_VALUE_MAP = {
  "1:10": {
    de: "1:10",
    en: "1:10",
    fr: "1:10",
    es: "1:10",
    nl: "1:10",
    it: "1:10",
    pl: "1:10",
    pt: "1:10",
    cs: "1:10",
    el: "1:10"
  },
  "1:12": {
    de: "1:12",
    en: "1:12",
    fr: "1:12",
    es: "1:12",
    nl: "1:12",
    it: "1:12",
    pl: "1:12",
    pt: "1:12",
    cs: "1:12",
    el: "1:12"
  },
  "1:14": {
    de: "1:14",
    en: "1:14",
    fr: "1:14",
    es: "1:14",
    nl: "1:14",
    it: "1:14",
    pl: "1:14",
    pt: "1:14",
    cs: "1:14",
    el: "1:14"
  },
  "1:16": {
    de: "1:16",
    en: "1:16",
    fr: "1:16",
    es: "1:16",
    nl: "1:16",
    it: "1:16",
    pl: "1:16",
    pt: "1:16",
    cs: "1:16",
    el: "1:16"
  },
  "1:18": {
    de: "1:18",
    en: "1:18",
    fr: "1:18",
    es: "1:18",
    nl: "1:18",
    it: "1:18",
    pl: "1:18",
    pt: "1:18",
    cs: "1:18",
    el: "1:18"
  },
  "1:20": {
    de: "1:20",
    en: "1:20",
    fr: "1:20",
    es: "1:20",
    nl: "1:20",
    it: "1:20",
    pl: "1:20",
    pt: "1:20",
    cs: "1:20",
    el: "1:20"
  },
  "1:22,5": {
    de: "1:22,5 - Spur 2",
    en: "1:22,5 - Gauge 2",
    fr: "1:22,5 - Voie 2",
    es: "1:22,5 - Escala 2",
    nl: "1:22,5 - Spoor 2",
    it: "1:22,5 - Scala 2",
    pl: "1:22,5 - Skala 2",
    pt: "1:22,5 - Escala 2",
    cs: "1:22,5 - M\u011b\u0159\u00edtko 2",
    el: "1:22,5 - \u039a\u03bb\u03af\u03bc\u03b1\u03ba\u03b1 2"
  },
  "1:24": {
    de: "1:24 - Spur H",
    en: "1:24 - Gauge H",
    fr: "1:24 - Voie H",
    es: "1:24 - Escala H",
    nl: "1:24 - Spoor H",
    it: "1:24 - Scala H",
    pl: "1:24 - Skala H",
    pt: "1:24 - Escala H",
    cs: "1:24 - M\u011b\u0159\u00edtko H",
    el: "1:24 - \u039a\u03bb\u03af\u03bc\u03b1\u03ba\u03b1 H"
  },
  "1:32": {
    de: "1:32 - Spur 1",
    en: "1:32 - Gauge 1",
    fr: "1:32 - Voie 1",
    es: "1:32 - Escala 1",
    nl: "1:32 - Spoor 1",
    it: "1:32 - Scala 1",
    pl: "1:32 - Skala 1",
    pt: "1:32 - Escala 1",
    cs: "1:32 - M\u011b\u0159\u00edtko 1",
    el: "1:32 - \u039a\u03bb\u03af\u03bc\u03b1\u03ba\u03b1 1"
  },
  "1:35": {
    de: "1:35",
    en: "1:35",
    fr: "1:35",
    es: "1:35",
    nl: "1:35",
    it: "1:35",
    pl: "1:35",
    pt: "1:35",
    cs: "1:35",
    el: "1:35"
  },
  "1:43": {
    de: "1:43",
    en: "1:43",
    fr: "1:43",
    es: "1:43",
    nl: "1:43",
    it: "1:43",
    pl: "1:43",
    pt: "1:43",
    cs: "1:43",
    el: "1:43"
  },
  "1:48": {
    de: "1:48 - Spur 0",
    en: "1:48 - Gauge 0",
    fr: "1:48 - Voie 0",
    es: "1:48 - Escala 0",
    nl: "1:48 - Spoor 0",
    it: "1:48 - Scala 0",
    pl: "1:48 - Skala 0",
    pt: "1:48 - Escala 0",
    cs: "1:48 - M\u011b\u0159\u00edtko 0",
    el: "1:48 - \u039a\u03bb\u03af\u03bc\u03b1\u03ba\u03b1 0"
  },
  "1:50": {
    de: "1:50",
    en: "1:50",
    fr: "1:50",
    es: "1:50",
    nl: "1:50",
    it: "1:50",
    pl: "1:50",
    pt: "1:50",
    cs: "1:50",
    el: "1:50"
  },
  "1:64": {
    de: "1:64 - Spur S",
    en: "1:64 - Gauge S",
    fr: "1:64 - Voie S",
    es: "1:64 - Escala S",
    nl: "1:64 - Spoor S",
    it: "1:64 - Scala S",
    pl: "1:64 - Skala S",
    pt: "1:64 - Escala S",
    cs: "1:64 - M\u011b\u0159\u00edtko S",
    el: "1:64 - \u039a\u03bb\u03af\u03bc\u03b1\u03ba\u03b1 S"
  },
  "1:72": {
    de: "1:72 - 25mm",
    en: "1:72 - 25mm",
    fr: "1:72 - 25mm",
    es: "1:72 - 25mm",
    nl: "1:72 - 25mm",
    it: "1:72 - 25mm",
    pl: "1:72 - 25mm",
    pt: "1:72 - 25mm",
    cs: "1:72 - 25mm",
    el: "1:72 - 25mm"
  },
  "1:87": {
    de: "1:87 - H0",
    en: "1:87 - H0",
    fr: "1:87 - H0",
    es: "1:87 - H0",
    nl: "1:87 - H0",
    it: "1:87 - H0",
    pl: "1:87 - H0",
    pt: "1:87 - H0",
    cs: "1:87 - H0",
    el: "1:87 - H0"
  }
};

function mapScaleFilterValueForLocale(value, localeCode) {
  const sourceValue = String(value || '').trim();
  if (!sourceValue) return sourceValue;

  const normalizedLocale = String(localeCode || '')
    .toLowerCase()
    .split('-')[0];
  const scaleMatch = sourceValue.match(/^(\d+:\d+(?:,\d+)?)/);
  if (!scaleMatch) return sourceValue;

  const scaleKey = scaleMatch[1];
  const localeValueMap = ZD_SCALE_FILTER_VALUE_MAP[scaleKey];
  if (!localeValueMap) return sourceValue;

  return localeValueMap[normalizedLocale] || sourceValue;
}

function remapLocaleSearchParams(search, localeCode) {
  if (!search) return '';

  const query = search.startsWith('?') ? search.slice(1) : search;
  const params = new URLSearchParams(query);
  const scaleParamName = 'filter.v.m.custom.ma_stab';
  const currentScaleValues = params.getAll(scaleParamName);

  if (currentScaleValues.length > 0) {
    params.delete(scaleParamName);
    currentScaleValues.forEach((value) => {
      params.append(scaleParamName, mapScaleFilterValueForLocale(value, localeCode));
    });
  }

  const mappedQuery = params.toString();
  return mappedQuery ? `?${mappedQuery}` : '';
}

if (typeof window.redirectToLocale !== 'function') {
  window.redirectToLocale = function(selectEl) {
    if (!selectEl || !selectEl.value) return;
    const code = String(selectEl.value).toLowerCase();
    const domainMap = {
      de: '3drifter-miniatures.de',
      en: '3drifter-miniatures.com',
      fr: '3drifter-miniatures.fr',
      es: '3drifter-miniaturas.es',
      nl: '3drifter-miniaturen.nl'
    };
    const deLocalePrefixMap = {
      it: '/it',
      pl: '/pl',
      cs: '/cs',
      pt: '/pt-pt',
      el: '/el'
    };

    const path = window.location.pathname || '/';
    const normalizedPath = path.replace(/^\/(de|en|fr|es|nl|it|pl|cs|pt|pt-pt|el)(\/|$)/i, '/');
    const suffixPath = normalizedPath === '' ? '/' : normalizedPath;
    const search = remapLocaleSearchParams(window.location.search || '', code);
    const hash = window.location.hash || '';

    let host = domainMap[code] || '3drifter-miniatures.de';
    let prefix = '';
    if (!domainMap[code]) {
      prefix = deLocalePrefixMap[code] || '';
    }
    window.location.href = `https://${host}${prefix}${suffixPath}${search}${hash}`;
  };
}

document.addEventListener('DOMContentLoaded', initCustomDawnMenus);
document.addEventListener('shopify:section:load', initCustomDawnMenus);
document.addEventListener('DOMContentLoaded', initZDFacetAutoClose);
document.addEventListener('shopify:section:load', initZDFacetAutoClose);
document.addEventListener('DOMContentLoaded', initZDFacetSummaryToggleFix);
document.addEventListener('shopify:section:load', initZDFacetSummaryToggleFix);
document.addEventListener('DOMContentLoaded', initZDSideNavToggles);
document.addEventListener('shopify:section:load', initZDSideNavToggles);
document.addEventListener('DOMContentLoaded', initZDHeaderIconTooltips);
document.addEventListener('shopify:section:load', initZDHeaderIconTooltips);
